const initialState = {
  data:{},
  search:'',
  filter:{type:'', srvc:null, ctype: ''},
  sort:{
    field:'comp_desc',
    asc:1
  }
};

export default (state = initialState, action = {}) => {
  switch(action.type) {
    case 'FETCH_COMPS':
      return {
        ...state,
        data:  action.payload
      }
    case 'SORT_COMPS':
      return {
        ...state,
        sort: action.sort
      }
    case 'SEARCH_COMPS':
      return {
        ...state,
        search: action.search
      }
    case 'FILTER_COMPS':
      return {
        ...state,
        filter: action.filter
      }
    case 'EDIT_COMP':
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.comp_id]:action.payload
        }
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/comps.js